import { Injectable } from "@angular/core";
import { HttpClient, HttpHeaders } from "@angular/common/http";
import { AppSettings } from "../shared/AppSettings";

@Injectable()
export class ReportService {
  readonly rootUrl = AppSettings.webApiURL;

  constructor(public httpClient: HttpClient) {}

  public getPaymentConfirmersList() {
    const headers = new HttpHeaders().set("content-type", "application/json");
    return this.httpClient.post(
      `${this.rootUrl}/api/Report/GetPaymentConfirmersList`,
      null,
      { headers }
    );
  }

  public getReportCustomerInvoices(invoiceFilter) {
    const headers = new HttpHeaders().set("content-type", "application/json");
    return this.httpClient.post(
      `${this.rootUrl}/api/Report/GetReportCustomerInvoices`,
      invoiceFilter,
      { headers }
    );
  }

  public printSelectedInvoices(selectedInvoices: any[]) {
    return this.httpClient.post(
      `${this.rootUrl}/api/Report/PrintSelectedInvoices`,
      selectedInvoices,
      {
        responseType: "blob", // force binary
        headers: new HttpHeaders({ "Content-Type": "application/json" }),
      }
    );
  }
}



// WEBPACK FOOTER //
// C:/MyProjects_Git/GoDocu/GoDocuMng/Client/src/app/service/report.service.ts